import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

// Generic scroll-reveal wrapper. Renders any motion tag via `as`.
export const Reveal = ({ children, as = "div", delay = 0, y = 34, className = "", ...rest }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-10% 0px" }}
      transition={{ duration: 0.85, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

// Kinetic heading: each line masked and revealed line-by-line on load.
const container = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.11, delayChildren: 0.25 } },
};
const lineVariant = {
  hidden: { y: "115%" },
  visible: { y: "0%", transition: { duration: 0.95, ease: [0.16, 1, 0.3, 1] } },
};

export const MaskLines = ({ lines, className = "", testId }) => (
  <motion.h1
    className={className}
    initial="hidden"
    animate="visible"
    variants={container}
    data-testid={testId}
  >
    {lines.map((content, i) => (
      <span className="mask-line" key={i}>
        <motion.span className="mask-inner" variants={lineVariant}>
          {content}
        </motion.span>
      </span>
    ))}
  </motion.h1>
);

// Subtle parallax image used in the feature moment.
export const ParallaxImage = ({ photo }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-14%", "14%"]);
  return (
    <div className="parallax-wrap" ref={ref} data-testid={`image-${photo.filename}`}>
      <motion.img style={{ y }} src={photo.src} alt={photo.alt} loading="lazy" />
    </div>
  );
};
